import { GET_CLUB_FULFILLED, GET_CLUB_REJECTED } from 'constants/ActionTypes';
const clubsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_CLUB_FULFILLED: {
            return Object.assign(Object.assign({}, state), action.payload.data);
        }
        case GET_CLUB_REJECTED: {
            return Object.assign(Object.assign({}, state), action.payload.data);
        }
        default:
            return state;
    }
};
export default clubsReducer;
